<template>
  <head>
    <title>{{ $t("Navbar.Projects") }}</title>
  </head>
  <div class="admin-projectss">
    <SideBar>
      <div class="container bg-light h-100 overflow-scroll">
        <div class="d-flex justify-content-center align-items-center mt-5 mb-3">
          <div class="w-100 d-flex justify-content-start align-items-center">
            <h3>{{ $t("Navbar.Projects") }} ({{ data.length }})</h3>
          </div>
          <div class="w-100 d-flex justify-content-end align-items-center">
            <button
              type="button"
              class="add-btn"
              @click="$router.push('/admin-add-project')"
            >
              {{ $t("dashboard.AddProject") }}
            </button>
          </div>
        </div>
        <div class="search-bar w-100 my-4">
          <input
            type="text"
            class="my-inp w-50"
            style="border: 1px solid black"
            :placeholder="$t('dashboard.SearchProject')"
            v-model="search_for"
            v-on:input="SearchByName()"
          />
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.NameAr") }}</th>
                <th scope="col">{{ $t("dashboard.NameEn") }}</th>
                <th scope="col">{{ $t("dashboard.TextAr") }}</th>
                <th scope="col">{{ $t("dashboard.TextEn") }}</th>
                <th scope="col">{{ $t("dashboard.img") }}</th>
                <th scope="col">{{ $t("dashboard.edit") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
                <th scope="col">{{ $t("dashboard.ShowMore") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in shown_data" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>{{ item.name_ar }}</td>
                <td>{{ item.name_en }}</td>
                <td>{{ item.description_ar }}</td>
                <td>{{ item.description_en }}</td>
                <td>
                  <img
                    :src="$store.state.server_images + encodeURI(item.image)"
                    alt=""
                    style="height: 100px; width: fit-content"
                  />
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-success"
                    @click="$router.push('/admin-edit-project?id=' + item.id)"
                  >
                    {{ $t("dashboard.edit") }}
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click="deleteProject(item.id)"
                  >
                    {{ $t("dashboard.delete") }}
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-warning"
                    @click="
                      ShowMore(item);
                      showmore = 1;
                    "
                  >
                    {{ $t("dashboard.ShowMore") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </SideBar>
    <div class="popup" v-if="showmore">
      <div class="close" @click="closeShowMore()">X</div>
      <div class="row w-100 mt-5">
        <div class="col-4 mt-5">
          <button
            type="button"
            class="btn w-100 my-4 btn-warning"
            @click="
              typeShow = 1;
              ids = [];
              api = 'project-delete-image';
            "
          >
            {{ $t("dashboard.img") }}
          </button>
        </div>
        <div class="col-4 mt-5">
          <button
            type="button"
            class="btn w-100 my-4 btn-warning"
            @click="
              typeShow = 2;
              ids = [];
              api = 'project-delete-plan';
            "
          >
            {{ $t("Plans") }}
          </button>
        </div>
        <div class="col-4 mt-5">
          <button
            type="button"
            class="btn w-100 my-4 btn-warning"
            @click="
              typeShow = 3;
              ids = [];
              api = 'project-delete-video';
            "
          >
            {{ $t("dashboard.videos") }}
          </button>
        </div>
        <div class="col-4">
          <button
            type="button"
            class="btn w-100 my-4 btn-warning"
            @click="
              typeShow = 4;
              ids = [];
              api = 'project-delete-certificate';
            "
          >
            {{ $t("Certificates") }}
          </button>
        </div>
        <div class="col-4">
          <button
            type="button"
            class="btn w-100 my-4 btn-warning"
            @click="
              typeShow = 5;
              ids = [];
              api = 'project-delete-payment';
            "
          >
            {{ $t("expenses") }}
          </button>
        </div>
        <div class="col-4">
          <button
            type="button"
            class="btn w-100 my-4 btn-warning"
            @click="
              typeShow = 6;
              ids = [];
              api = 'project-delete-service';
            "
          >
            {{ $t("dashboard.services") }}
          </button>
        </div>
        <div class="col-12">
          <button
            type="button"
            class="btn w-100 my-4 btn-danger"
            @click="deleteAttachment()"
          >
            {{ $t("dashboard.delete") }}
          </button>
        </div>
        <div class="table-responsive col-12">
          <table class="table table-striped table-hover" v-if="typeShow == 1">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.img") }}</th>
                <th scope="col">{{ $t("dashboard.editNumber") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in images" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>
                  <img
                    :src="$store.state.server_images + encodeURI(item.image)"
                    alt=""
                    style="height: 100px; width: fit-content"
                  />
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-success"
                    @click="EditImageNumber(item.id, item.order_num, index)"
                  >
                    {{ $t("dashboard.editNumber") }}
                  </button>
                </td>
                <td>
                  <input
                    type="checkbox"
                    @click="AddRemoveAttachment(item.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped table-hover" v-if="typeShow == 2">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.img") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in plans" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>
                  <img
                    :src="$store.state.server_images + encodeURI(item.image)"
                    alt=""
                    style="height: 100px; width: fit-content"
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    @click="AddRemoveAttachment(item.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped table-hover" v-if="typeShow == 3">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.videos") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in videos" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>
                  <video
                    class="my-video"
                    controls
                    @contextmenu.prevent
                    style="height: 100px; width: fit-content"
                    controlsList="nodownload"
                  >
                    <source
                      :src="$store.state.server_images + item.video"
                      type="video/mp4"
                    />
                    Your browser does not support HTML5 video.
                  </video>
                </td>
                <td>
                  <input
                    type="checkbox"
                    @click="AddRemoveAttachment(item.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped table-hover" v-if="typeShow == 4">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.img") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in certificates" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>
                  <img
                    :src="$store.state.server_images + encodeURI(item.image)"
                    alt=""
                    style="height: 100px; width: fit-content"
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    @click="AddRemoveAttachment(item.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped table-hover" v-if="typeShow == 5">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("expenses") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in payments" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>
                  {{ item.image }}
                </td>
                <td>
                  <input
                    type="checkbox"
                    @click="AddRemoveAttachment(item.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped table-hover" v-if="typeShow == 6">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ $t("dashboard.icon") }}</th>
                <th scope="col">{{ $t("dashboard.delete") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in services" :key="index">
                <th scope="row">{{ item.id }}</th>
                <td>
                  <Icon :icon="item.icon" height="24" width="24" />
                </td>
                <td>
                  <input
                    type="checkbox"
                    @click="AddRemoveAttachment(item.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/AdminDashboard/SideBar.vue";
import store from "@/store";
import axios from "axios";
import { Icon } from "@iconify/vue";
export default {
  name: "admin-products",
  data() {
    return {
      data: [],
      shown_data: [],
      search_for: "",
      images: [],
      videos: [],
      certificates: [],
      payments: [],
      plans: [],
      services: [],
      showmore: 0,
      typeShow: 1,
      api: "project-delete-image",
      ids: [],
    };
  },
  components: {
    SideBar,
    Icon,
  },
  methods: {
    closeShowMore() {
      location.reload();
    },
    getData() {
      axios
        .get(store.state.server + "get-all-projects")
        .then((response) => {
          this.data = response.data;
          this.SearchByName();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    SearchByName() {
      this.shown_data =
        this.search_for === ""
          ? this.data
          : this.data.filter(
              (item) =>
                item.name_ar.includes(this.search_for) ||
                item.name_en
                  .toLowerCase()
                  .includes(this.search_for.toLowerCase())
            );
    },
    deleteProject(id) {
      let conf = window.confirm("هل تريد الحذف؟");
      if (conf) {
        const token = store.state.token;
        if (!token) {
          alert("Token is missing");
          this.dis = "none";
          this.Zindex = -3;
          return;
        }
        axios
          .get(store.state.server + "project-delete/" + id, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.status === 200) {
              alert("DONE");
              location.reload();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    ShowMore(item) {
      this.images = [];
      this.videos = [];
      this.certificates = [];
      this.payments = [];
      this.plans = [];
      this.services = [];
      if (item.images) {
        this.images = item.images;
      }
      if (item.videos) {
        this.videos = item.videos;
      }
      if (item.certificates) {
        this.certificates = item.certificates;
      }
      if (item.payments) {
        this.payments = item.payments;
      }
      if (item.plans) {
        item.plans.forEach((plan) => {
          this.plans.push({
            id: plan.id,
            image: plan.plan.image,
          });
        });
      }
      if (item.services) {
        item.services.forEach((service) => {
          this.services.push({
            id: service.id,
            icon: service.service.icon,
          });
        });
      }
    },
    AddRemoveAttachment(id) {
      const index = this.ids.indexOf(id);
      if (index > -1) {
        this.ids.splice(index, 1); // Remove the element at the specified index
      } else {
        this.ids.push(id); // Add the element if it's not in the array
      }
    },
    deleteAttachment() {
      let conf = window.confirm("هل تريد الحذف؟");
      if (conf) {
        const token = store.state.token;
        if (!token) {
          alert("Token is missing");
          this.dis = "none";
          this.Zindex = -3;
          return;
        }
        if (this.ids.length == 0) {
          alert(
            this.$i18n.locale === "ar"
              ? "اختر العناصر من فضلك"
              : "Please select attachments first"
          );
          return;
        }
        axios
          .get(store.state.server + this.api, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            params: { id: this.ids }, // Pass `id` as query parameters
          })
          .then((response) => {
            if (response.status === 200) {
              location.reload();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    EditImageNumber(id, num, index) {
      let conf = window.prompt("ادخل الرقم", num);
      if (conf > 0) {
        const token = store.state.token;
        if (!token) {
          alert("Token is missing");
          this.dis = "none";
          this.Zindex = -3;
          return;
        }
        const api = store.state.server + "update-order-img/" + id;
        axios
          .post(
            api,
            { order_num: conf },
            { headers: { Authorization: `Bearer ${token}` } }
          )
          .then((response) => {
            if (response.status === 200) {
              alert("تم التعديل بنجاح");
              this.images[index].order_num = conf;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        alert("يجب ان يكون الرقم اكبر من الصفر");
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  backdrop-filter: blur(10px);
  z-index: 100000000;
  height: 100vh;
  width: 98.9vw;
  overflow-y: scroll;
}

.close {
  position: absolute;
  top: 30px;
  left: 30px;
  padding: 20px;
  font-size: 24px;
  color: whitesmoke;
  z-index: 100000001;
  cursor: pointer;
  background-color: crimson;
  border-radius: 25%;
}
</style>
